import type { GetStaticProps } from 'next'
import { Image } from '~/elements/Image/Image'
import { NextSeo } from 'next-seo'
import { Headline } from '~/elements/Headline/Headline'
import { useTranslation } from 'next-i18next'
import { NextPageWithLayout } from './_app'
import { StaticShape } from '~/elements/OrganicShape/StaticShape'
import tailwindConfig from '~/theme'
import { ButtonMain } from '~/elements/Button/ButtonMain'
import { getStaticPropsNext } from '~/next-modules/getStaticProps'
import Layout from '~/modules/Layout/Layout'
import dynamic from 'next/dynamic'

const CmsPage = dynamic(() => import('~/modules/CmsPage/CmsPage'))

const Custom404: NextPageWithLayout = () => {
  const { t } = useTranslation()

  return (
    <>
      <NextSeo title="404" />
      <div className="pt-[var(--header-padding)]">
        <section className="content-width relative flex flex-col items-center overflow-hidden p-4 pb-10 md:flex-row md:p-8 md:pb-28 md:pt-14">
          <div className="relative h-full w-[70%] self-start md:w-1/2 md:self-auto">
            <div className={'relative -z-10 h-full w-full'}>
              <StaticShape color={tailwindConfig.theme.colors.secondary['light-olive']} />
            </div>
            <div className="pointer-events-none absolute top-0 left-0 flex h-full w-full items-center justify-center">
              <Image
                src="/images/Icons/404.svg"
                width={534}
                height={354}
                placeholder="empty"
                className="h-1/2 w-1/2 lg:h-[60%] lg:w-[60%]"
                alt="404-icon"
              />
            </div>
          </div>
          <div className="relative h-full w-full md:w-1/2">
            <div className="flex h-full w-full items-center justify-center p-4">
              <div className="max-w-full md:max-w-[350px] lg:max-w-[450px]">
                <Headline type="h1" className="mb-4 text-center md:text-left lg:mb-6">
                  {t('404title')}
                </Headline>
                <p className="mb-4 lg:mb-6">{t('404text')}</p>
                <ButtonMain className="w-full md:w-2/3" href="/" variant="Main">
                  {t('Back to homepage')}
                </ButtonMain>
              </div>
            </div>
          </div>
        </section>
      </div>
      <CmsPage slug="404" paddingTop={false} />
    </>
  )
}

Custom404.getLayout = (Custom404) => <Layout>{Custom404}</Layout>

const getStaticProps: GetStaticProps = getStaticPropsNext({ slug: '404' })
export { getStaticProps }

export default Custom404
